import { Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { StoreService } from '../services/store.service';
import { of } from 'rxjs';

@Injectable()
export class StoreListingResolver implements Resolve<any> {
  constructor(private storeService: StoreService) {}

  public storeList: any = undefined;
  resolve() {
    if (this.storeList) {
        return this.getSavedStoresList();
      } else {
        return this.getStoresFromApi();
      }
  }

  private getSavedStoresList(): any {
    return of(this.storeList);
  }

  private getStoresFromApi(): any {
  
  return this.storeService.getStoreList('', 0 , 5 , true , Number(localStorage.getItem('userId')), false);
  }
}
